import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';
import { IProduct, IChip } from '@alycecom/ui';

import { IPagination, ISort, IFilters } from './products.types';

const PREFIX = 'MARKETPLACE/PRODUCTS';

export const loadProductsSuccess = createAction<{ products: IProduct[]; pagination: IPagination }>(
  `${PREFIX}/LOAD_PRODUCTS_SUCCESS`,
);
export const loadProductsFail = createAction<TLegacyErrors>(`${PREFIX}/LOAD_PRODUCTS_FAIL`);

export const setLoading = createAction<boolean>(`${PREFIX}/SET_LOADING`);
export const setFilter = createAction<{ key: keyof IFilters; items: number[] }>(`${PREFIX}/SET_FILTER`);
export const setSearch = createAction<string>(`${PREFIX}/SET_SEARCH`);
export const setSorting = createAction<ISort>(`${PREFIX}/SET_SORTING`);
export const setPage = createAction<number>(`${PREFIX}/SET_PAGE`);

export const resetProducts = createAction<void>(`${PREFIX}/RESET_PRODUCTS`);
export const resetFilters = createAction<void>(`${PREFIX}/RESET_FILTERS`);

export const addChip = createAction<IChip>(`${PREFIX}/ADD_CHIP`);
export const deleteChip = createAction<IChip>(`${PREFIX}/DELETE_CHIP`);
export const clearAllChips = createAction<void>(`${PREFIX}/CLEAR_ALL_CHIPS`);
export const setChips = createAction<IChip[]>(`${PREFIX}/SET_CHIPS`);

export const setAllFilters = createAction<IFilters>(`${PREFIX}/SET_ALL_FILTERS`);
export const setCountryId = createAction<number>(`${PREFIX}/SET_COUNTRY_ID`);
